import { CreateExternalEventEventDocument, CreateExternalEventLocationDocument } from '@/generated/graphql';
import { useMyUser, waitForUser } from '@/user/composables/useMyUser';
import { useMutation } from '@vue/apollo-composable';
import { Ref, toValue } from 'vue';
import { ExternalEventEventCreateSchemaType } from '../schemas';

export function useExternalEventEventCreate(data: Ref<ExternalEventEventCreateSchemaType>, seriesId: Ref<string>) {
    const createExternalEvent = useMutation(CreateExternalEventEventDocument);
    const createLocationMutation = useMutation(CreateExternalEventLocationDocument);

    const { currentUser } = useMyUser();

    async function create() {
        await waitForUser(currentUser);
        const saveData = {
            seriesId: toValue(seriesId),
            ...toValue(data),
            createdById: currentUser.value.id,
            createdByName: currentUser.value.name,
        };
        const res = await createExternalEvent.mutate(saveData);
        const event = res?.data?.create?.externalEvent ?? undefined;
        return { event, errors: res?.errors ?? [] };
    }

    async function createInternationalLocation(eventId: string, locationName: string) {
        return await createLocationMutation.mutate({
            eventId,
            locationName,
        });
    }

    return {
        create,
        createInternationalLocation,
    };
}
